
const languageNav = document.querySelector('.wpml-ls');
const languageToggles = document.querySelectorAll('.wpml-ls-item-toggle');

languageToggles.forEach(languageToggle => {
	languageToggle.addEventListener('click', (event) => {
		event.preventDefault();

		if( languageToggle.classList.contains('is-langswitcher-open') ) {
			closeLangnav();
			return;
		}

		languageToggle.classList.add('is-langswitcher-open');
	});
});

function closeLangnav() {
	document.querySelectorAll('.is-langswitcher-open').forEach(item => {
		item.classList.remove('is-langswitcher-open');
	});
}

document.addEventListener('click', event => {
	const isLangClickOutside = !languageNav.contains(event.target);

	if ( isLangClickOutside ) {
		closeLangnav();
	}
});
